import { createStyles } from "@mantine/core";
import { ReactNode } from "react";

const useStyles = createStyles((theme) => ({
  root: {
    height: "100vh",
  },
}));

export const FullScreenPage = ({ children }: { children: ReactNode }) => {
  const { classes } = useStyles();
  return <div className={classes.root}>{children}</div>;
};
